import { render, staticRenderFns } from "./ActionButton.template.vue?vue&type=template&id=01450ffb&scoped=true&"
var script = {}
import style0 from "./ActionButton.template.vue?vue&type=style&index=0&id=01450ffb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01450ffb",
  null
  
)

export default component.exports